import React from 'react';
import { NavLink } from 'react-router-dom';
import { alpha, Box, Button, useMediaQuery } from '@mui/material';
import { HeaderMenu } from '../types';
import { DefaultTheme } from '@mui/styles';
import HeaderUserMenu from './HeaderUserMenu';

interface Props {
	items: HeaderMenu;
}

export default function HeaderMainMenu({ items }: Props) {
	const isMobile = useMediaQuery((theme: DefaultTheme) => theme.breakpoints.down('md'));

	return (
		<Box mb={isMobile ? 4 : 0}>
			{items.map((item, index) => (
				<Box component={isMobile ? 'div' : 'span'} key={index} data-cy="nav-button">
					{item.submenu ? (
						<HeaderUserMenu
							items={item.submenu.menu}
							buttonText={item.submenu.buttonText}
						/>
					) : (
						<Button
							variant="text"
							component={NavLink}
							to={item.path}
							sx={{
								color: (theme) =>
									alpha('light' === theme.palette.mode ? '#000' : '#fff', 0.87),
								borderColor: (theme) =>
									alpha('light' === theme.palette.mode ? '#000' : '#fff', 0.23),
								lineHeight: 1.8,

								'&.active': {
									fontWeight: 700,
									color: 'secondary.main',
								},
							}}
						>
							{item.label}
						</Button>
					)}
				</Box>
			))}
		</Box>
	);
}
